<div *ngIf="!(hasRoute('login') || hasRoute('consumer') || hasRoute('signin') || hasRoute('resetpw'))">
  <app-topnav></app-topnav>
  <app-sidenav></app-sidenav>
</div>
<router-outlet></router-outlet>
